import { Brick, registerBrick } from 'olympe';
import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ReactDOM from "react-dom";
import {getIcon} from "../utils/_icons.jsx";

export default class ErrorPopup extends Brick {

    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (title, text, color, icon) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} title
     * @param {string} text
     * @param {olympe.df.Color} color
     * @param {string} icon
     * @param {function()} forwardEvent
     */
    onUpdate(context, [title, text, color, icon], [forwardEvent]) {
        const errorPopupId = 'errorPopup017bbb453d7d598c63f6';
        if (!document.getElementById(errorPopupId)) {
            const head = document.body;
            const errorPopup = document.createElement('div');
            errorPopup.id = errorPopupId;
            head.appendChild(errorPopup);
        }

        ReactDOM.render((<ErrorPopup.Component
            title={title}
            text={text}
            context={context}
            color={color}
            icon={icon}
            forwardEvent={forwardEvent}
        />), document.getElementById(errorPopupId));
    }
}

ErrorPopup.Component = (props) => {
    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
        const el = document.getElementById('errorPopup017bbb453d7d598c63f6');
        if(el !== null) {
            el.remove();
        }
        props.forwardEvent();
    };

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            aria-labelledby="error-popup-title"
            style={{flexDirection: 'row'}}
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: props.color.toHexString(), width: '20%', height: 'auto'}}>
                    {getIcon(props.icon, true, {style: {color: 'white', position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}})}
                </div>
                <div>
                    <DialogTitle id="error-popup-title">{props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="error-popup-description">
                            {props.text}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>
                            Ok
                        </Button>
                    </DialogActions>
                </div>
            </div>

        </Dialog>
    );

}

registerBrick('017bbb453d7d598c63f6', ErrorPopup);
